import fetch from "@lib/fetch";
import { API } from "../../config";
import axios from "axios";

export const createProduct = (token, data) => {
    return fetch(`${API}/v1/products`,{
        mode: 'cors',
        method: "POST",
        headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
            Authorization: `Bearer ${token}`
        },
        body: JSON.stringify(data)
    })
        .then(response => {
            return response.json()
        })
        .catch(error => {
            console.log(error);
        })
};

export const createProductByAdmin = (token, userId, newCatalog) => {
    let data = {
        user_id: userId,
        name: newCatalog.productName,
        sku: newCatalog.productSku,
        details: newCatalog.productDetails,
        category: newCatalog.productCategory,
        image: newCatalog.productImage,
        length: newCatalog.productLength,
        width: newCatalog.productWidth,
        height: newCatalog.productHeight,
        weight: newCatalog.productWeight,
        price: newCatalog.productPrice,
        stock: newCatalog.productStock,
        status: newCatalog.productStatus
    };

    return fetch(`${API}/v1/admin/products`,{
        mode: 'cors',
        method: "POST",
        headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
            Authorization: `Bearer ${token}`
        },
        body: JSON.stringify(data)
    })
        .then(response => {
            return response.json()
        })
        .catch(error => {
            console.log(error);
        })
};

export const updateProductByAdmin = (token, userId, data) => {
    return fetch(`${API}/v1/admin/products/users/${userId}`,{
        mode: 'cors',
        method: "PUT",
        headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
            Authorization: `Bearer ${token}`
        },
        body: JSON.stringify(data)
    })
        .then(response => {
            return response.json()
        })
        .catch(error => {
            console.log(error);
        })
};

export const updateProduct = (token, data) => {
    return fetch(`${API}/v1/products`,{
        mode: 'cors',
        method: "PUT",
        headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
            Authorization: `Bearer ${token}`
        },
        body: JSON.stringify(data)
    })
    .then(response => {
        return response.json()
    })
    .catch(error => {
        console.log(error);
    })
};

export const deleteProduct = (token, productId) => {
    return fetch(`${API}/v1/products/${productId}`,{
        mode: 'cors',
        method: "DELETE",
        headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
            Authorization: `Bearer ${token}`
        }
    })
        .then(response => {
            return response.json()
        })
        .catch(error => {
            console.log(error);
        })
};
export const deleteProductByAdmin = (token, userId, productId) => {
    return fetch(`${API}/v1/admin/products/${productId}/users/${userId}`,{
        mode: 'cors',
        method: "DELETE",
        headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
            Authorization: `Bearer ${token}`
        }
    })
        .then(response => {
            return response.json()
        })
        .catch(error => {
            console.log(error);
        })
};

export const updateProductImage = async (token, image) => {
    let data = new FormData();
    data.append('productImage', image);
    const res = await axios.post(`${API}/v1/products/image`, data, {
        mode: 'cors',
        method: "POST",
        headers: {
            'Content-Type': 'multipart/form-data',
            Authorization: `Bearer ${token}`
        }
    });
    if(res.data.success) {
        return res.data
    } else {
        alert(res.data.message);
    }
};

export const checkProductAvailability = async (catalogId, userId, data) => {
    return fetch(`${API}/v1/products/check/${catalogId}/${userId}`,{
        mode: 'cors',
        method: "POST",
        headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json'
        },
        body: JSON.stringify(data)
    })
    .then(response => {
        return response.json()
    })
    .catch(error => {
        console.log(error);
    })
};